import axios from "axios";

export const createGatesLibrary = async (username, gatesReportLibraryVO) => {
    try {
        const {data} = await axios.post("/api/gatesReportLibrary/create",{username, gatesReportLibraryVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveAllGatesLibraries = async (username) => {
    try {
        const {data} = await axios.get("/api/gatesReportLibrary/viewAll?username=" + username);
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const retrieveGatesLibrary = async (username, gatesReportLibraryExternalReference) => {
    try {
        const {data} = await axios.post("/api/gatesReportLibrary/view", {username, gatesReportLibraryExternalReference});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const updateGatesLibrary = async (username, gatesReportLibraryVO) => {
    try {
        const {data} = await axios.put("/api/gatesReportLibrary/update", {username, gatesReportLibraryVO});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}

export const deleteGatesLibrary = async (username, externalReference) => {
    try {
        const {data} = await axios.delete("/api/gatesReportLibrary/delete", {data: {username, externalReference}});
        return [data, null];
    } catch (error) {
        return [null, error];
    }
}
